import React, { useState } from 'react';
import  { useFetchContent } from '../hooks/useFetchData';
import MainLayout from '../components/layouts/MainLayout';
import Breadcrumb from '../components/shared/Breadcrumbs';

const TermOfUsePage = () => {
  const { data: content, loading, error } = useFetchContent(); 
  console.log(content)

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "利用規約", path: "/terms-of-service" },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;
  const item = content.find(obj => obj.key === "terms-of-use");
  

  return (
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div className='term'>
        <h2>{item.value}</h2>
        <span style={{whiteSpace: "pre-wrap"}}>{item.text}</span>
      </div>
    </MainLayout>
  );
};
export default TermOfUsePage;